<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
  export default {
  name: "App",
  data() {
    return {};
  },
  mounted() {
     window.localStorage.setItem("ischinese", "en");
  }
};
</script>
<style lang="stylus">
#app
  font-family Avenir, Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  height 100%
html,
body {
  margin: 0;
  padding: 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
